import React, { useEffect, useRef, useState } from 'react'
import { Box } from '@ui'
import { SECOND_MS } from 'data/constants'

import beaverSleep from './assets/beaver-gap.png'
import beaver from './assets/beaver16x.png'
import beaverBlink from './assets/beaver16x-blink.png'

type Props = {
    isActive: boolean
}

export const BeaverHead = (props: Props) => {
    const { isActive } = props
    const [isBlinking, setIsBlinking] = useState(false)
    const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined)
    const rafRef = useRef<number | undefined>(undefined)
    const isActiveRef = useRef(isActive)

    useEffect(() => {
        isActiveRef.current = isActive
    }, [isActive])

    useEffect(() => {
        const beaverImg = new Image()
        beaverImg.src = beaver
        const beaverBlinkImg = new Image()
        beaverBlinkImg.src = beaverBlink
        const beaverSleepImg = new Image()
        beaverSleepImg.src = beaverSleep
    }, [])

    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
            timeoutRef.current = undefined
        }
        if (rafRef.current) {
            cancelAnimationFrame(rafRef.current)
            rafRef.current = undefined
        }

        if (!isActive) {
            setIsBlinking(false)
            return
        }

        const blink = () => {
            if (!isActiveRef.current) {
                return
            }

            setIsBlinking(true)

            timeoutRef.current = setTimeout(() => {
                if (!isActiveRef.current) {
                    setIsBlinking(false)
                    return
                }

                setIsBlinking(false)

                if (isActiveRef.current) {
                    timeoutRef.current = setTimeout(
                        () => {
                            if (isActiveRef.current) {
                                rafRef.current = requestAnimationFrame(blink)
                            }
                        },
                        SECOND_MS * (0.5 + Math.random() * 5),
                    )
                }
            }, 100)
        }

        rafRef.current = requestAnimationFrame(blink)

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
                timeoutRef.current = undefined
            }
            if (rafRef.current) {
                cancelAnimationFrame(rafRef.current)
                rafRef.current = undefined
            }
            setIsBlinking(false)
        }
    }, [isActive])

    return (
        <Box centerContent position="relative" square="square_sm">
            {isActive ? (
                <>
                    <BeaverImage src={beaver} visible={!isBlinking} />
                    <BeaverImage src={beaverBlink} visible={isBlinking} />
                </>
            ) : (
                <BeaverImage visible src={beaverSleep} />
            )}
        </Box>
    )
}

const BeaverImage = (props: { src: string; visible: boolean }) => {
    return (
        <Box
            absoluteFill
            opacity={props.visible ? 'opaque' : 'transparent'}
            style={{
                background: `url(${props.src}) no-repeat center / contain`,
            }}
        />
    )
}
